module.exports = __webpack_public_path__ + "static/media/pencil-white.4be8ab75.svg";